import { Container, SearchBoxContainer } from 'components/search/SearchBanner/components';

import BannerContainer from 'components/layout/BannerContainer';
import BannerText from 'components/layout/BannerText';
import BannerTitle from 'components/layout/BannerTitle';
import CourseSearch from 'components/forms/CourseSearch';
import FlexContainer from 'components/common/FlexContainer';
import InstitutionSearch from 'components/forms/InstitutionSearch';
import SkipNavLocation from 'components/common/SkipNavLocation';
import { Spin } from 'antd';
import useTranslation from 'hooks/use-translation';

export default function SearchBanner(): JSX.Element {
  const translation = useTranslation();

  if (!translation) {
    return <Spin />;
  }

  return (
    <BannerContainer className='banner-container'>
      <SkipNavLocation>
        <Container>
          <FlexContainer gap={16} className='search-banner-text-container'>
            <BannerTitle className='banner-title'>{translation.home.searchTitle}</BannerTitle>
            <FlexContainer>
              {translation.home.searchDescription.map((description) => (
                <BannerText className='banner-text' key={description}>
                  {description}
                </BannerText>
              ))}
            </FlexContainer>
          </FlexContainer>
          <SearchBoxContainer className='search-inputs-container'>
            <InstitutionSearch />
            <CourseSearch />
          </SearchBoxContainer>
        </Container>
      </SkipNavLocation>
    </BannerContainer>
  );
}
